<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
    <div class="home-content common-home-content max-640">
        <div class="main-jing-container ice_bg" v-show="show">
          <div class="jingluo_data">
            <div class="section_jq section-bor-bom" v-if="jingluo_data.jing_disease">
                <h2>{{jingluo_data.jing_disease}}</h2>
                <div class="p-content pr">
                    {{jingluo_data.disease_yangsheng}}
                </div>
            </div>
            <div class="section_jq section-bor-bom" v-else>
                <h2>养生建议</h2>
                <div class="p-content clearfix pr">
                    <img :src="jingluo_data.jing_image" class="fl fl-img fl_img" alt="">
                    {{jingluo_data.yangsheng}}
                </div>
            </div>
            
            <div class="section_jq">
                <h2>经络按摩</h2>
                <div class="p-content clearfix pr">
                    <img :src="jingluo_data.anmo_image" class="fl fl-img fl_img" alt="">
                    {{jingluo_data.anmo_content}}
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      locData: {},
      show: false,
      jingluo_data: {}
    };
  },
  created() {
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadinti(){
        var that = this;
        that.$api.get("/health/getlunardata", "").then(function(res) {
            that.locData = res.data.data;
            that.jingluo_data = that.locData.jing_data;
            var jing_diseases = [];
            for(var k in that.locData.jing_data.disease){
                jing_diseases.push(k);
            }
            var exist_disease = that.$utils.getUrlKey("d");
            if(exist_disease){
                if(jing_diseases.indexOf(exist_disease) > -1 && exist_disease != '常规'){
                    that.jingluo_data['jing_disease'] = exist_disease;
                    that.jingluo_data['disease_yangsheng'] = that.locData.jing_data.disease[exist_disease].yang;
                }else{
                    that.jingluo_data['jing_disease'] = '';
                }
            }
            that.show = true;
            
        });
    },
    pageback(){
        var exist_disease = this.$utils.getUrlKey("d");
        if(exist_disease){
          this.$router.push({ path: "/?d="+exist_disease});
        }else{
          this.$router.push({ path: "/"});
        }
        return true;
    }  
  }
}
</script>

